const common = require('./common/constants')
const multipleAssessmentReport = require('./multipleAssessmentReport')

module.exports = {
  common,
  multipleAssessmentReport,
}
